<template>
  <div>
    <router-view v-if="$route.name !== 'VATReportBEList'"></router-view>
    <VATReportBEList v-else></VATReportBEList>
  </div>
</template>
<script>
import VATReportBEList from "@/views/gekko/VATReportBEList";

export default {
  name: "VATReportBEHome",
  components: {VATReportBEList, }
}
</script>